<template>
<div class="rhesis">
  <!-- 输入框 -->
  <el-input v-model="title" placeholder="题目" style="width:30%" @keyup.enter.native="handleSearch"></el-input>
  <el-button type="primary" @click="handleSearch">搜索</el-button>
  <el-divider></el-divider>
  <!-- rhesis内容 -->
  <el-table
    :data="tableData"
    style="width: 100%"
    stripe
    v-loading.fullscreen.lock="fullscreenLoading"
  >
    <el-table-column prop="title" label="名字" width="auto"> </el-table-column>
    <el-table-column prop="title_url" label="下载链接" width="150px" fixed="left" >
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click = "getDownloadAddr(scope.row.title_url)">
                下载
                <i class="el-icon-download el-icon--right"></i>
              </el-button>
            </template>
    </el-table-column>
  </el-table>
  <el-divider></el-divider>
  <!-- 分页码器 -->
  <el-pagination
    background
    layout="prev, pager, next"
    :total="total"
    class="pagination"
    @current-change="changePage"
  >
  </el-pagination>
</div>
</template>

<script>
import axios from 'axios'
import surl from '@/common'
export default {
  name: 'Kindle',
  methods: {
    getDownloadAddr (addr) {
      this.titleUrl = addr
      console.log(addr)
      // window.open(addr)
      window.location.href = addr
    },
    handleRhesis (res) {
      var dt = res.data.data
      console.log(dt)
      this.tableData = dt.kindle_books
      this.page = dt.page
      this.perPage = dt.per_page || 10
      this.total = dt.total
      this.fullscreenLoading = false
    },
    changePage (pageNum) {
      this.fullscreenLoading = true
      if (this.title === '') {
        var url = surl.PROD_URL + '/v1/kindle_books?order_by=id:0&url=1&page=' + pageNum
      } else {
        url = surl.PROD_URL + '/v1/kindle_books?order_by=id:0&url=1&page=' + pageNum + '&filter_by=title:$like:' + this.title
        console.log(url)
      }
      axios.get(url)
        .then(this.handleRhesis)
    },
    handleSearch () {
      this.fullscreenLoading = true
      if (this.author === '' && this.title === '') {
        this.$confirm('请输入有效的诗词名字或者作者')
      } else {
        let url = surl.PROD_URL + '/v1/kindle_books?order_by=id:0&url=1&filter_by=title:$like:' + this.title
        console.log(url)
        axios.get(url)
          .then(this.handleRhesis)
      }
    }
  },
  data () {
    return {
      fullscreenLoading: true,
      tableData: [],
      page: 0,
      perPage: 10,
      total: 10,
      title: '',
      author: '',
      content: '',
      titleUrl: ''
    }
  },
  mounted: function () {
    axios.get(surl.PROD_URL + '/v1/kindle_books?order_by=id:0&url=1')
      .then(this.handleRhesis)
  }
}
</script>

<style>
  .rhesis {
    width: -moz-fit-content;
    width: -webkit-fit-content;
    width: 70%;
    margin: 30px auto;
  }

  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
  .pagination {
    width: -moz-fit-content;
    width: -webkit-fit-content;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Kindle/Kindle.vue